import { ConcreteEncodable } from "./ConcreteEncodable";

import { MarketDataEventImplEncoder } from "../../encoder/MarketDataEventImplEncoder";

import * as CubiqTS from "../../index";
import { MarketDataEvent } from "../MarketDataEvent";

export class MarketDataEventImpl extends ConcreteEncodable implements MarketDataEvent {
  public static enType: string = "com.bcdfx.streaming.MarketDataEventImpl";

  /*FID=1*/
  public eventType: CubiqTS.EventType;
  /*FID=3*/
  public rateData: Array<CubiqTS.MarketRate> | null = null;
  /*FID=4*/
  public subscriptionCode: string;
  /*FID=5*/
  public providerId: number;
  /*FID=6*/
  public providerCode: string;
  /*FID=7*/
  public rateSource: string;
  /*FID=8*/
  public feedDown: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = MarketDataEventImplEncoder.Instance;
    this.setEncodableType(MarketDataEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "MarketDataEventImpl[" +
      "eventType=" +
      this.eventType +
      "rateData=" +
      this.rateData +
      "subscriptionCode=" +
      this.subscriptionCode +
      "providerId=" +
      this.providerId +
      "providerCode=" +
      this.providerCode +
      "rateSource=" +
      this.rateSource +
      "feedDown=" +
      this.feedDown +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
